<div class="flex mb-3">
  <p-iconField iconPosition="left">
    <p-inputIcon styleClass="fas fa-search" />
    <input
      class="w-20rem"
      pInputText
      #searchQuery
      (keydown)="updateList(searchQuery.value)"
      placeholder="durchsuchen ..." />
  </p-iconField>
</div>
<p-accordion *ngIf="itemsFiltered.length" [activeIndex]="0">
  @for (indicator of itemsFiltered; track indicator.key) {
    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="flex gap-3 align-items-center">
          <i *ngIf="icon" [class]="icon"></i>
          <span>{{ indicator.name }}</span>
          <span class="kbd absolute top-0 right-0 m-0">{{
            indicator.key
          }}</span>
        </div>
      </ng-template>
      <ng-container *ngIf="indicator.validation.errors as errors">
        <div *ngIf="errors['access']" class="px-3 py-3" appAlertStyle="error">
          <i class="fas fa-exclamation-circle mr-2"></i>
          <strong>Keine Rechte</strong> Ihnen fehlen die Zugriffsrechte für den
          Indikatorenordner.
        </div>
        <div *ngIf="errors['double']" class="px-3 py-3" appAlertStyle="error">
          <i class="fas fa-exclamation-circle mr-2"></i>
          <strong>Doppelte Schlüssel</strong> innerhalb der Excel gefunden.
        </div>
        <div *ngIf="errors['key']" class="px-3 py-3" appAlertStyle="error">
          <i class="fas fa-exclamation-circle mr-2"></i>
          <strong>Schlüssel nicht valide</strong>
        </div>
        <div *ngIf="errors['category']" class="px-3 py-3" appAlertStyle="error">
          <i class="fas fa-exclamation-circle mr-2"></i>
          @if (errors['category'] === 'k. A.') {
            Es wurde kein Ordner angegeben.
          } @else {
            <strong>{{ errors['category'] }}</strong> ist kein Ordner in ihrem
            Indikatorenverzeichnis.
          }
        </div>
      </ng-container>
      <ng-container *ngIf="indicator.validation.warnings as warnings">
        <div
          *ngIf="warnings['products']"
          class="px-3 py-3"
          appAlertStyle="warning">
          <i class="fas fa-exclamation-triangle mr-2"></i>
          <strong>Produkte</strong> nicht gefunden!
        </div>
        <div *ngIf="warnings['tags']" class="px-3 py-3" appAlertStyle="warning">
          <i class="fas fa-exclamation-triangle mr-2"></i>
          <strong>Schlagworte</strong> nicht gefunden! Diese werden beim Import
          ignoriert.
        </div>
        <div
          *ngIf="warnings['noChildrenFound']"
          class="px-3 py-3"
          appAlertStyle="warning">
          <i class="fas fa-exclamation-triangle mr-2"></i>
          <strong>Ausprägungen</strong> nicht gefunden! Diese werden beim Import
          ignoriert.
        </div>
        <div
          *ngIf="warnings['parentNotFound']"
          class="px-3 py-3"
          appAlertStyle="warning">
          <i class="fas fa-exclamation-triangle mr-2"></i>
          <strong>Indikatorenset</strong>
          <i> "{{ warnings['parentNotFound'] }}"</i> nicht gefunden!
          <strong>Groß- und Kleinschreibung beachten!</strong> Das Set wird beim
          Import ignoriert.
        </div>
      </ng-container>

      <div class="p-datatable">
        <table class="p-datatable-table">
          <tbody class="p-datatable-tbody">
            <tr>
              <td class="text-right"><strong>Name</strong></td>
              <td>{{ indicator.name }}</td>
            </tr>
            <tr>
              <td class="text-right"><strong>Schlüssel</strong></td>
              <td>
                <i
                  class="fas fa-exclamation-circle mr-2"
                  *ngIf="
                    indicator.validation.errors &&
                    indicator.validation.errors['key']
                  "></i
                >{{ indicator.key }}
              </td>
            </tr>
            <tr>
              <td class="text-right"><strong>Ordner</strong></td>
              <td>
                @if (indicator.pool) {
                  <i>Poolimport ohne Ordner</i>
                } @else if (
                  indicator.validation.errors &&
                  indicator.validation.errors['category']
                ) {
                  <i class="fas fa-exclamation-circle mr-2"></i>
                  {{ indicator.category || 'nicht angegeben' }}
                } @else {
                  <i class="fas fa-folder mr-2"></i>
                  {{
                    indicator.category
                      ? categoryStore.getById(indicator.category)?.name
                      : 'nicht angegeben'
                  }}
                }
              </td>
            </tr>
            <tr>
              <td class="text-right"><strong>Einheit</strong></td>
              <td>
                <app-unit [unitKey]="indicator.unit" mode="name"></app-unit>
              </td>
            </tr>
            <tr>
              <td class="text-right"><strong>Schlagwort</strong></td>
              <td>
                <div class="flex gap-2">
                  <app-tag-list
                    *ngIf="indicator.tags && indicator.tags.length > 0"
                    [tagIds]="indicator.tags"></app-tag-list>
                  <div
                    *ngIf="
                      indicator.validation &&
                      indicator.validation.warnings &&
                      indicator.validation.warnings['tags']
                    "
                    class="flex align-items-center gap-2 flex-wrap">
                    <p-tag
                      [rounded]="true"
                      icon="fas fa-exclamation-triangle"
                      *ngFor="let tag of indicator.validation.warnings['tags']"
                      [value]="tag"></p-tag>
                  </div>
                  @if (!indicator.tags || indicator.tags.length === 0) {
                    <i class="text-color-secondary">nicht angegeben</i>
                  }
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-right"><strong>Berechnung</strong></td>
              <td
                [class]="
                  indicator.calculation
                    ? ''
                    : 'font-italic text-color-secondary'
                "
                [innerHTML]="indicator.calculation || 'nicht angegeben'"></td>
            </tr>
            <tr>
              <td class="text-right"><strong>Hinweis auf</strong></td>
              <td
                [class]="
                  indicator.hint ? '' : 'font-italic text-color-secondary'
                "
                [innerHTML]="indicator.hint || 'nicht angegeben'"></td>
            </tr>
            <tr>
              <td class="text-right"><strong>Aussage</strong></td>
              <td
                [class]="
                  indicator.statement ? '' : 'font-italic text-color-secondary'
                "
                [innerHTML]="indicator.statement || 'nicht angegeben'"></td>
            </tr>
            <tr>
              <td class="text-right"><strong>Quelle</strong></td>
              <td
                [class]="
                  indicator.source ? '' : 'font-italic text-color-secondary'
                "
                [innerHTML]="indicator.source || 'nicht angegeben'"></td>
            </tr>
            <tr>
              <td class="text-right"><strong>Erhebungszyklus</strong></td>
              <td
                [class]="
                  indicator.dataCycle ? '' : 'font-italic text-color-secondary'
                "
                [innerHTML]="indicator.dataCycle || 'nicht angegeben'"></td>
            </tr>
            <tr>
              <td class="text-right">
                <strong>Ebene der Verfügbarkeit</strong>
              </td>
              <td
                [class]="
                  indicator.levelOfAvailability
                    ? ''
                    : 'font-italic text-color-secondary'
                "
                [innerHTML]="
                  indicator.levelOfAvailability || 'nicht angegeben'
                "></td>
            </tr>
            <tr>
              <td class="text-right"><strong>Datenlieferant</strong></td>
              <td
                [class]="
                  indicator.dataSupplier
                    ? ''
                    : 'font-italic text-color-secondary'
                "
                [innerHTML]="indicator.dataSupplier || 'nicht angegeben'"></td>
            </tr>
            <tr>
              <td class="text-right"><strong>Gesperrt</strong></td>
              <td>
                <i
                  [class]="
                    indicator.locked ? 'fas fa-lock-open' : 'fas fa-lock'
                  "></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </p-accordionTab>
  }
</p-accordion>
